import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-processing-loader',
    templateUrl: './processing-loader.component.html',
    styleUrls: ['./processing-loader.component.scss'],
})
export class ProcessingLoaderComponent implements OnInit {
    @Input() loadingMessage: string;
    progress: number = 0;

    ngOnInit() {
        this.simulateProgress();
    }

    private simulateProgress() {
        const totalTime = 3;
        const totalProgress = 95;
        const stepTime = totalTime / 95;

        const interval = setInterval(() => {
            if (this.progress < totalProgress) {
                this.progress += stepTime * 10;
            } else {
                clearInterval(interval);
            }
        }, stepTime * 1000);
    }
}
